import { PERMISSIONS, getAdminPermissionsForOrg } from "../constants/permissions";
import { getOrgPermissionModuleVisibility } from "./orgModuleAccess";

/**
 * Sidebar-aligned module icons + colors for the permission tree.
 * Keep in sync with `components/layout/Sidebar.js` menu icons/colors.
 */
export const PERMISSION_TREE_MODULE_META = {
  admin: { icon: "fa-wrench", color: "#198754" },
  study: { icon: "fa-gear", color: "#6f42c1" },
  isf: { icon: "fa-folder", color: "#0d6efd" },
  capa: { icon: "fa-clipboard-check", color: "#e0a800" },
  eplanner: { icon: "fa-calendar-check", color: "#198754" },
  participantManager: { icon: "fa-user-friends", color: "#fd7e14" },
  qms: { icon: "fa-file-alt", color: "#243f5a" },
};

/**
 * Assignable permission groups for user/role UI.
 * Only includes modules the organisation is licensed for (`userData.Modules`).
 */
export function buildRolePermissionTreeGroups(userData) {
  const visibility = getOrgPermissionModuleVisibility(userData);
  const groups = [];

  const pushGroup = (id, label, permissions) => {
    const meta = PERMISSION_TREE_MODULE_META[id] || {
      icon: "fa-cube",
      color: "#64748b",
    };
    groups.push({
      id,
      label,
      icon: meta.icon,
      color: meta.color,
      permissions,
    });
  };

  if (visibility.admin) {
    pushGroup("admin", "Admin", getAdminPermissionsForOrg(userData));
  }
  if (visibility.studyUser) {
    pushGroup("study", "Study Management", PERMISSIONS.STUDY_MANAGEMENT);
  }
  if (visibility.isf) {
    pushGroup("isf", "ISF / PSF", PERMISSIONS.ISF_PSF);
  }
  if (visibility.capa) {
    pushGroup("capa", "CAPA", PERMISSIONS.CAPA);
  }
  if (visibility.ePlanner) {
    pushGroup("eplanner", "E-Planner", PERMISSIONS.EPLANNER);
  }
  if (visibility.participantManager) {
    pushGroup(
      "participantManager",
      "Participant Manager",
      PERMISSIONS.PARTICIPANT_MANAGER,
    );
  }
  if (visibility.qms) {
    pushGroup("qms", "QMS", PERMISSIONS.QMS_ROLE_PROFILE);
  }

  return groups.filter((group) => (group.permissions || []).length > 0);
}

export function filterRolePermissionTreeGroups(groups, searchTerm = "") {
  const query = String(searchTerm || "").trim().toLowerCase();
  if (!query) return groups;

  return groups
    .map((group) => {
      const groupMatch = String(group.label || "").toLowerCase().includes(query);
      const permissions = (group.permissions || []).filter((permission) => {
        const label = String(permission.label || "").toLowerCase();
        const key = String(permission.key || "").toLowerCase();
        return label.includes(query) || key.includes(query);
      });

      if (groupMatch) return group;
      if (!permissions.length) return null;
      return { ...group, permissions };
    })
    .filter(Boolean);
}
